import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YdsCardComponent, YdsSpinnerComponent } from '../../yds-angular';
import { environment } from '../../../environments/environment';
import { isTestEnvironment } from '../../shared/environment.util';
import {
  LoginInformationService,
  UserInfo,
  EntitlementsResponse,
} from '../login-information.service';

@Component({
  selector: 'app-login-information',
  imports: [CommonModule, YdsCardComponent, YdsSpinnerComponent],
  templateUrl: './login-information.component.html',
  styleUrl: './login-information.component.scss',
})
export class LoginInformationComponent implements OnInit {
  private readonly loginInformationService = inject(LoginInformationService);

  readonly isLoading = signal(true);
  readonly userInfo = signal<UserInfo | null>(null);
  readonly entitlements = signal<EntitlementsResponse | null>(null);
  readonly decodedJwtToken = signal<unknown | null>(null);
  readonly isJwtTokenAvailable = isTestEnvironment();
  readonly environmentName = environment.name;

  ngOnInit(): void {
    let infoLoaded = false;
    let entitlementsLoaded = false;

    const checkDone = () => {
      if (infoLoaded && entitlementsLoaded) {
        this.isLoading.set(false);
      }
    };

    this.loginInformationService.getUserInfo().subscribe((info) => {
      this.userInfo.set(info);
      infoLoaded = true;
      checkDone();
    });

    this.loginInformationService.getEntitlements().subscribe((data) => {
      this.entitlements.set(data);
      entitlementsLoaded = true;
      checkDone();
    });

    if (this.isJwtTokenAvailable) {
      this.loginInformationService.getDecodedJwtToken().subscribe((token) => {
        this.decodedJwtToken.set(token);
      });
    }
  }
}
